import { TGetUserSettingOutputDto } from "@/api/services/main/user-setting/dtos/get-user-setting.dto";
import { TUpdateUserSettingReqDto } from "@/api/services/main/user-setting/dtos/update-user-setting.dto";
import { TUserSettingForm } from "@/features/user-setting/types/UserSettingForm";

const intiForm = {
  emailDeliveryOptions: [],
};

export const getInitValues = () => {
  return {
    ...intiForm,
  };
};

export const convertFormDataToReqDto = (data: TUserSettingForm): TUpdateUserSettingReqDto => {
  const matchOfficeId = data.matchOfficeId ? Number(data.matchOfficeId) : null;

  return {
    ...intiForm,
    emailDeliveryOptions: data.emailDeliveryOptions ?? undefined,
    userDepartment: data.userDepartment ?? "",
    userPosition: data.userPosition ?? "",
    matchOfficeId: matchOfficeId,
  };
};

export const convertResDtoToFormData = (data: TGetUserSettingOutputDto): TUserSettingForm => {
  return {
    ...data,
    emailDeliveryOptions: data.emailDeliveryOptions ?? undefined,
    userDepartment: data.userDepartment ?? undefined,
    userPosition: data.userPosition ?? undefined,
    matchOfficeId: data.matchOfficeId ?? undefined,
  };
};
